import { ENV_TYPE } from '@red/data-access';

export const environment = {
  name: ENV_TYPE.SIT,
  production: true,
  // apiConfig: 'https://t4fxouxkyafnq67dgoiz4mazji0axwdi.lambda-url.ap-southeast-1.on.aws/?app=dsme',
  apiConfig: window.location.origin + '/config/external/config.json',
};
